import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './aws-config';
import { AuthProvider } from './auth/AuthContext';
import { NotificationProvider } from './notifications/NotificationContext';
import { ProfileProvider } from './profile/ProfileContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AuthProvider><ProfileProvider><NotificationProvider><App /></NotificationProvider></ProfileProvider></AuthProvider>
    </React.StrictMode>
  </BrowserRouter>
);
